import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import EContentCom from './EContent';
import FooterMore from "../common/FooterMore";
import { NoRightCom, handleHeight } from '../../util/common';
import EContent from "../news/EContent";

// ecode自定义元素
class EcodeElement extends React.Component {
    state = {loading: false, deleted: false};

    constructor(props) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.handleEData = this.handleEData.bind(this);
        this.onRef = this.onRef.bind(this);
        // this.handleTabData = this.handleTabData.bind(this);
    }

    componentWillMount() {
        const {config = {}} = this.props;
        const {item = {}} = config;
        const {custom = {}} = item;
        const {modulename, packagename} = custom;

        if (modulename && !window[packagename]) {
            this.setState({loading: true});
            WeaTools.loadDevModules(modulename, packagename).then(() => {
                const _interval = window.setInterval(() => {
                    if (window[packagename]) {
                        this.setState({loading: false});
                        window.clearInterval(_interval);
                    }
                }, 100);
            });
        }
    }

    componentDidMount(){
        const { config = {} } = this.props;
        const { params = {} } = config;
        const { eid } = params;
        const edata = ls.getJSONObj(`edata-${eid}`);
        if (config.islsdata && edata) {
            this.setState({ edata });
        } else {
            this.handleEData(params);
        }
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = {
            item: nextProps.config.item,
            params: nextProps.config.params,
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = {
            item: nextProps.config.item,
            params: nextProps.config.params,
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config) || !isEmpty(nextProps.fontSizeMp)
    }

    onRef(ref){
        this.child = ref;
    }

    handleEData(params){
        const { eid, api } = params;
        WeaTools.callApi(api || '/api/portal/element/ecodeelement', 'POST', {...params}).then(result=> {
            ls.set('edata-'+eid, result);
            this.setState({
                edata: result,
                loading: false,
            });
        });
    }

    render() {
        const {loading, deleted} = this.state;
        // 元素已删除，返回空
        if (deleted) return <div/>;
        const { edata={} } = this.state;
        const {config, fontSizeMp} = this.props;
        if(!config || !edata) return <div/>;
        const {isHasRight, isSetting, item, params, synergyParams} = config;
        const {eid, ebaseid, style, contentview, custom = {}} = item;
        const {style: style1= {}} = contentview;

        let EContentHtml = <div/>;
        if(isHasRight){
            if(!isEmpty(edata)) EContentHtml = <EContentCom onRef={this.onRef} config={config} ref={"eContent"} fontSizeMp={fontSizeMp} handleDelete={this.handleDelete} handleRefresh={this.handleRefresh} edata={edata} />;
        }else{
            EContentHtml = <NoRightCom/>
        }

        return (
            <div className="item"
                style={style}
                id={`item_${eid}`}
                data-eid={eid} data-ebaseid={ebaseid}
                data-needRefresh={item.needRefresh}
                data-cornerTop={item.cornerTop}
                data-cornerTopRadian={item.cornerTopRadian}
                data-cornerBottom={item.cornerBottom}
                data-cornerBottomRadian={item.cornerBottomRadian}>
                <EHeader config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                <div className="setting" id={`setting_${eid}`}></div>
                <div className="content" id={`content_${eid}`} style={{width: 'auto', _width: '100%'}}>
                    <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                        <Spin spinning={loading}>{EContentHtml}</Spin>
                    </div>
                    <div style={{textAlign: 'right'}} id={`footer_${eid}`}>
                        <FooterMore config={this.props.config}/>
                    </div>
                </div>
            </div>
        );
    }

    handleRefresh() {
        this.setState({
            loading: true,
        });
        this.handleEData(this.props.config.params);
    }

    handleDelete() {
        this.setState({deleted: true});
    }
}

export default EcodeElement






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/ecodeelement/index.js